import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { MaxBrainUtils } from 'app/projects/core/src/lib/utils';
import { EntityState } from 'app/projects/entity/src/lib/models/entity.state';
import { AddUserSectionStats, AddUserSectionStatsForParticipant, FetchUserSectionStatsForParticipantFailure, FetchUserSectionStatsForParticipantSuccess } from '../actions';
import { UserSectionStats } from './user-section.model';
import { UserSectionStateModel } from './user-section.state-model';

@State<UserSectionStateModel>({
    name: 'userSectionStats',
    defaults: new UserSectionStateModel(),
})
@Injectable()
export class UserSectionStatsState extends EntityState<UserSectionStats> {
    private static sortProperties: string[] = ['id'];

    @Selector()
    static getEntities(state: UserSectionStateModel): UserSectionStats[] {
        if (!state.map) {
            return null;
        }

        const toReturn = Array.from(state.map.values());

        toReturn.sort(MaxBrainUtils.sortCompareFn(UserSectionStatsState.sortProperties));

        return toReturn;
    }

    @Selector()
    static getEntity(state: UserSectionStateModel, id: string = state.item): UserSectionStats {
        if (!state.map) {
            return null;
        }
        return state.map.get(id);
    }

    constructor() {
        super(null, 0);

        this._propstoSearch = ['user', 'firstName', 'lastName', 'sectionStats', 'section', 'name'];
    }

    @Action(AddUserSectionStats)
    addEntities(ctx: StateContext<UserSectionStateModel>, action: AddUserSectionStats): void {
        this._addEntities(ctx, action);
    }

    @Action(AddUserSectionStatsForParticipant)
    addEntitiesForParticipant(ctx: StateContext<UserSectionStateModel>, action: AddUserSectionStatsForParticipant): void {
        this._addEntities(ctx, action);
    }

    @Action(FetchUserSectionStatsForParticipantSuccess)
    fetchEntitiesSuccessParticipant(ctx: StateContext<UserSectionStateModel>): void {
        this._fetchEntitiesSuccess(ctx);
    }

    @Action(FetchUserSectionStatsForParticipantFailure)
    fetchEntitiesFailureParticipant(ctx: StateContext<UserSectionStateModel>): void {
        this._fetchEntitiesFailure(ctx);
    }
}
